<!--
 * @Author: wumao
 * @Date: 2021-12-21 09:27:41
 * @LastEditors: wumao
 * @LastEditTime: 2021-12-21 14:32:58
 * @Description: 
-->
<template>
  <div class="step">
    <div class="dot"></div>
    <div class="line" v-if="!noLine"></div>
  </div>
</template>

<script>
export default {
  props: {
    noLine: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="less" scoped>
.step {
  .dot {
    width: 0.14rem;
    height: 0.14rem;
    background: #0072f7;
    border-radius: 50%;
    z-index: 1;
  }
  .line {
    width: 1px;
    height: 1.2rem;
    background: #eee;
    margin-left: 0.06rem;
    z-index: 0;
  }
}
</style>
